module.exports = __webpack_public_path__ + "img/view-img.0bb81ad2.svg";